import HttpHelper from '@/helpers/http';
import { IFile } from '@/helpers/upload';

interface IFileUpload {
  success: boolean;
  files: IFile[];
}

export default class UploadApi {
  static async upload(data): Promise<IFileUpload> {
    return await HttpHelper.post('/api/v1/files/uploads', data);
  }

  static async getFile(): Promise<IFileUpload> {
    return await HttpHelper.get('/api/v1/files/uploads');
  }

  static async removeFile(fileName: string) {
    return await HttpHelper.delete(`/api/v1/files/uploads/${fileName}`);
  }
}
